import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";

@Injectable()
export class AudioInputSignalService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('audio-input-signals', service);
  }

}




// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-speaker-setup/services/audio-input-signal.service.ts